import React, { useEffect, useState } from "react";
export function LocalClock({
  className = ""
}: {
  className?: string;
}) {
  const [time, setTime] = useState("");
  useEffect(() => {
    const update = () => {
      setTime(new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        timeZoneName: "short"
      }).format(new Date()));
    };
    update();
    const interval = window.setInterval(update, 30000);
    return () => window.clearInterval(interval);
  }, []);
  if (!time) return null;
  return <span className={className} data-id="element-321" data-mp="14tulso7jfv31">Your time {time}</span>;
}